import { z } from 'zod';
export const estimatingImportCapability = 'estimating.import-reconciliation.v1';
export const estimatingImportManifestVersion = 'estimating-source-manifest.v1';
export const estimatingImportMappingVersion = 'estimating-normalized-v1';
export const estimatingImportRunStatusSchema = z.enum([
    'prepared', 'applying', 'reconciled', 'failed', 'rolled-back',
]);
export const estimatingImportCountsByEntitySchema = z.strictObject({
    estimate: z.number().int().nonnegative().safe(),
    'pricebook-category': z.number().int().nonnegative().safe(),
    'pricebook-item': z.number().int().nonnegative().safe(),
    'estimate-template': z.number().int().nonnegative().safe(),
    'proposal-package': z.number().int().nonnegative().safe(),
    'xactimate-export-job': z.number().int().nonnegative().safe(),
});
export const estimatingImportDomainTotalsSchema = z.strictObject({
    estimateVersionCount: z.number().int().nonnegative().safe(),
    estimateLineCount: z.number().int().nonnegative().safe(),
    estimateAcceptanceCount: z.number().int().nonnegative().safe(),
    estimateTotalCents: z.number().int().nonnegative().safe(),
    estimateOptionalTotalCents: z.number().int().nonnegative().safe(),
    pricebookCategoryCount: z.number().int().nonnegative().safe(),
    pricebookItemCount: z.number().int().nonnegative().safe(),
    pricebookUnitPriceCents: z.number().int().nonnegative().safe(),
    templateVersionCount: z.number().int().nonnegative().safe(),
    templateLineCount: z.number().int().nonnegative().safe(),
    proposalPackageCount: z.number().int().nonnegative().safe(),
    proposalPackageTotalCents: z.number().int().nonnegative().safe(),
    xactimateJobCount: z.number().int().nonnegative().safe(),
    xactimateAttemptCount: z.number().int().nonnegative().safe(),
    xactimateOutputByteCount: z.number().int().nonnegative().safe(),
});
export const estimatingImportRunSummarySchema = z.strictObject({
    contractVersion: z.literal(estimatingImportCapability),
    tenantId: z.string().uuid(),
    id: z.string().uuid(),
    manifestVersion: z.literal(estimatingImportManifestVersion),
    mappingVersion: z.literal(estimatingImportMappingVersion),
    sourceSystem: z.literal('crest-crm'),
    sourceRepository: z.literal('jakeflora-cell/crest-crm'),
    sourceCommitSha: z.string().regex(/^[a-f0-9]{40}$/),
    sourceSchemaSha256: z.string().regex(/^[a-f0-9]{64}$/),
    sourceManifestSha256: z.string().regex(/^[a-f0-9]{64}$/),
    tenantExternalKey: z.string().trim().min(1).max(240),
    runKind: z.enum(['base', 'final-delta']),
    sourceEpoch: z.string().trim().min(1).max(240),
    parentSourceSha256: z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    sourceSha256: z.string().regex(/^[a-f0-9]{64}$/),
    planSha256: z.string().regex(/^[a-f0-9]{64}$/),
    status: estimatingImportRunStatusSchema,
    sourceRows: z.number().int().nonnegative(),
    plannedRows: z.number().int().nonnegative(),
    rejectedRows: z.number().int().nonnegative(),
    appliedRows: z.number().int().nonnegative().nullable(),
    skippedRows: z.number().int().nonnegative().nullable(),
    tombstonedRows: z.number().int().nonnegative().nullable(),
    targetSha256: z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    countsByEntity: estimatingImportCountsByEntitySchema.nullable(),
    domainTotals: estimatingImportDomainTotalsSchema.nullable(),
    failureReasonCode: z.string().trim().min(3).max(160).nullable(),
    rollbackReason: z.string().trim().min(10).max(1_000).nullable(),
    startedByMembershipId: z.string().uuid(),
    startedAt: z.string().datetime({ offset: true }),
    completedAt: z.string().datetime({ offset: true }).nullable(),
    rolledBackAt: z.string().datetime({ offset: true }).nullable(),
});
//# sourceMappingURL=estimating-import.contract.js.map